import { withDependencies } from '@wix/thunderbolt-ioc'
import type { TpaHandlerProvider } from '@wix/thunderbolt-symbols'
import type { ISessionManager } from 'feature-session-manager'
import { SessionManagerSymbol } from 'feature-session-manager'

export const SessionHandlerHandler = withDependencies(
	[SessionManagerSymbol],
	(sessionManager: ISessionManager): TpaHandlerProvider => ({
		getTpaHandlers() {
			return {
				getCtToken() {
					return sessionManager.getCtToken()
				},
				getUserSession() {
					return sessionManager.getUserSession()
				},
			}
		},
	})
)
